import React from "react";
import { IonPage, IonContent } from "@ionic/react";
import SmallHeader from "../../components/Header/SmallHeader";
import LargeHeader from "../../components/Header/LargeHeader";
import LinkList from "../../components/Link/LinkList";

const News = (props) => {
  React.useEffect(() => {
    //if(match && match.fixture.status.elapsed === 90 && moment().format() < moment(match.fixture.date).local().add(hoursToNote, 'hours').format()) {} else setShowVote(false);
console.log('afffffff')
    //if(match && match.fixture.status.elapsed === 90 && moment().format() < moment(match.fixture.date).local().add(hoursToNote, 'hours').format()) {} else setVoteFor("noteClose")

  }, []);
  return (
    <IonPage>
      <SmallHeader title="Buzz" />
      <IonContent fullscreen>
        <LargeHeader title="Buzz" />
        <LinkList location={props.location} />
      </IonContent>
    </IonPage>
  );
};

export default News;
